import InitStopClientLogic from "./StopClient.logic";

const StopClientComponent: React.FC = () => {
    const { selectedClients, clients, data, onSave, onChange, addClient, removeSelectedClient } = InitStopClientLogic();
    return (
        <div className="page-container">
            <h1 className="text-align-center">Stopiraj paket klijentu</h1>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <button className="btn-primary" type="button" onClick={onSave}>Sačuvaj</button>

                <div>
                    <label htmlFor="fromDate">Od (uključen)</label>
                    <input id="fromDate" type={"date"} value={data.fromDate} onChange={onChange} name="fromDate"></input>
                </div>

                <div>
                    <label htmlFor="toDate">Do (isključen)</label>
                    <input id="toDate" type={"date"} value={data.toDate} onChange={onChange} name="toDate"></input>
                </div>

                <div>
                    <label htmlFor="client">Pretraga klijenata</label>
                    <input placeholder="Traži po imenu ili prezimenu..." id="client" type={"text"} value={data.client} onChange={onChange} name="client"></input>
                </div>
            </div>

            {selectedClients.length > 0 && (
                <div className="card" style={{ marginTop: '16px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {selectedClients.map((c) =>
                            <button className="btn-secondary" type="button" key={c.id} onClick={() => removeSelectedClient(c)}>{c.firstName} {c.lastName}</button>
                        )}
                    </div>
                </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '12px' }}>
                {clients.map((c) => c.firstName.concat(" ", c.lastName).toLowerCase().replaceAll("ć","c").replaceAll("č","c").replaceAll("š","s").replaceAll("ž","z").replaceAll("đ","dj").includes(data.client.toLowerCase().replaceAll("ć","c").replaceAll("č","c").replaceAll("š","s").replaceAll("ž","z").replaceAll("đ","dj")) ? (
                    <button type="button" key={c.id} onClick={() => addClient(c)}>{c.firstName} {c.lastName}</button>
                ) : "")
                }
            </div>

            <div style={{ marginTop: '16px' }}>
                <button className="btn-primary" type="button" onClick={onSave}>Sačuvaj</button>
            </div>
        </div>
    );
}

export default StopClientComponent;
